import { Button, Card, Col, Form, Row } from "react-bootstrap";
import { Link } from "react-router-dom";
import { formatMoeda, handleNumberOnly, validarCPFCNPJ } from "../../utils/utils";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArrowLeft, faQrcode } from "@fortawesome/free-solid-svg-icons";
import { useState } from "react";

interface formProps {
    nome: string;
    cpfcnpj: string;
    recorrencia: string;
    valor: string;
}

const initialState: formProps = {
    nome: '',
    cpfcnpj: '',
    recorrencia: '3',
    valor: '600,00'
}

export default function AssinaturaForm() {
    const [form, setForm] = useState(initialState);

    const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        setForm({ ...form, [e.target.name]: e.target.value });
    };

    const handleSelect = (e: React.ChangeEvent<HTMLSelectElement>) => {
        let valorAssinatura = 0;
        if (e.target.value === '1') {
            valorAssinatura = 60.00;
        } 
        
        else if (e.target.value === '2') {
            valorAssinatura = 330.00;
        } 

        else if (e.target.value === '3') {
            valorAssinatura = 600.00;
        } 
        else {
            valorAssinatura = 60.00;
        }

        setForm({
            ...form, 
            [e.target.name]: e.target.value, 
            valor: formatMoeda(valorAssinatura)
        });
    };

    const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
        e.preventDefault();
        if (!validarCPFCNPJ(form.cpfcnpj)) {
            alert('CPF/CNPJ inválido');
            return;
        }
    };

    return (<div className="d-flex justify-content-center align-items-center vh-100">
        <div className="row col-md-6 mx-auto">

            <Form onSubmit={handleSubmit}>
                <Card className="card-primary card-outline">
                    <Card.Header>

                        <h5 className="text-center text-uppercase">Dados do comprador</h5>
                    </Card.Header>
                    <Card.Body>
                        <Row className="g-2">
                            <Col md>
                                <Form.Group className="mb-3" controlId="nome">
                                    <Form.Label>Nome</Form.Label>
                                    <Form.Control type="text" required maxLength={60} autoFocus value={form.nome}
                                        onChange={handleChange} name="nome" />
                                </Form.Group>
                            </Col>

                            <Col md={3}>
                                <Form.Group className="mb-3" controlId="cpfcnpj">
                                    <Form.Label>CPF/CNPJ</Form.Label>
                                    <Form.Control type="text" required maxLength={14} onKeyUp={handleNumberOnly}
                                        value={form.cpfcnpj} onChange={handleChange} name="cpfcnpj" />
                                </Form.Group>
                            </Col>

                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="recorrencia">
                                    <Form.Label>Recorrencia</Form.Label>
                                    <Form.Select required value={form.recorrencia} name="recorrencia"
                                        onChange={handleSelect}>
                                        {/* <option value="1">Mensal</option>
                                        <option value="2">Semestral</option> */}
                                        <option value="3">Anual</option>
                                    </Form.Select>
                                </Form.Group>
                            </Col>
                            <Col md={2}>
                                <Form.Group className="mb-3" controlId="valor">
                                    <Form.Label>Valor</Form.Label>
                                    <Form.Control type="text" readOnly
                                        value={ form.valor} name="valor" />
                                </Form.Group>
                            </Col>


                        </Row>
                    </Card.Body>
                    <Card.Footer>
                        <div className="row justify-content-end">
                            <div className="col-md">
                                <Link to="/licenca" className="btn btn-secondary me-2">
                                    <FontAwesomeIcon icon={faArrowLeft} /> Voltar
                                </Link>
                            </div>
                            <div className="col-md-auto">
                                <Button variant="primary" type="submit">
                                    <FontAwesomeIcon icon={faQrcode} /> Gerar QRCode
                                </Button>
                            </div>
                        </div>

                    </Card.Footer>
                </Card>
            </Form>
        </div>
    </div>)
}